// Libs
import { updateUserOnPubInfo, setConnectStatus, setReportInfo, resetUserOnPubInfo } from '@/redux/reducers/socket'

// Constants
import { WS_EVENT_TMS, SUB_STATUS, CONNECTION_STATUS } from '@/constants/socketEvent'

// Types
import { IMessage } from '../handleMessageReceive'

const tms = {
  action({ message, hostData, isHost, rtcData }: IMessage) {
    if (message.ssid === WS_EVENT_TMS.onpub) {
      const actionArray = []
      if (isHost) {
        actionArray.push(setConnectStatus({ connectStatus: CONNECTION_STATUS.CONNECTING }))
      }

      actionArray.push(handleOnPub({ message, hostData, isHost }))

      return actionArray
    } else if (message.ssid === WS_EVENT_TMS.onunpub) {
      if (isHost) {
        const data: any = message.body
        const { token } = data
        if (rtcData?.token === token) {
          console.log('onunpub reset rtcData user: ', token)
          return resetUserOnPubInfo()
        }
      }
    } else if (message.ssid === WS_EVENT_TMS.getReportUrl) {
      const data: any = message.body
      const { sessionId, statusUrl, webrtcStatsDuration, webrtcStatsUrl } = data
      // server 沒帶 webrtcStatsDuration 時不要把 reducer 預設值 (20000) 蓋成 undefined，
      // 否則 recorder/reporter 的 setInterval(fn, undefined) 會以 ~4ms 狂打 getStats
      const reportInfo: Record<string, any> = { sessionId, statusUrl, webrtcStatsUrl }
      if (webrtcStatsDuration) reportInfo.webrtcStatsDuration = webrtcStatsDuration
      return setReportInfo({ reportInfo })
    }
  },
}

export default tms

const handleOnPub = ({ message, hostData, isHost }: IMessage) => {
  const data: any = message.body

  const { video, token, audio, streamType = '' } = data

  const isHostOnPub = token === hostData.token

  if (!isHostOnPub && !isHost) return

  const onPubInfo = {
    video,
    audio,
    streamType,
  }
  const result = {
    onPubInfo,
    isSub: SUB_STATUS.SUBING,
    token,
  }

  return updateUserOnPubInfo({ rtcData: result })
}
